export class ImportMaps {
  Id: number;
  PlantId: number;
  TrainId:number;
  Default: string;
  Name: string;
  Parameters: string;
  CreatedAt: string;
  UpdatedAt: string;
}
